import { SUBMISSIONS } from '../models/submissions';

function delay(ms = 350) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** Todos los registros enviados, del más reciente al más antiguo. */
export async function getSubmissions() {
  await delay();
  return [...SUBMISSIONS].sort(
    (a, b) => new Date(b.submittedAt) - new Date(a.submittedAt)
  );
}

/** Registros enviados por un usuario puntual. */
export async function getSubmissionsByUser(userId) {
  await delay();
  const all = await getSubmissions();
  return all.filter((s) => s.submittedBy === userId);
}
